<template>
	<div class="wrap" id="main">
		<v-row
			style="max-width: 713px"
			no-gutters
			align="center"
			class="mx-auto pt-12 pt-sm-15"
		>
			<v-col cols="12" sm="6" class="text-center text-sm-left">
				<h1 class="main-title" v-html="$t('main.title')"></h1>
				<v-btn
					:href="`https://my.tella.co.kr/trial?_amp_d_id=${deviceId}`"
					class="rounded-lg text-body-1 mt-4 mt-sm-9 mb-5 mb-sm-0 main-button"
					large
					color="primary"
					@click="clickTrialBridge"
					><strong class="font-wieght-bold">{{ $t('main.button') }} </strong>
				</v-btn>
			</v-col>
			<v-col cols="12" sm="6" class="text-center text-sm-right">
				<MainImage />
			</v-col>
		</v-row>
	</div>
</template>

<script>
// import amplitude from 'amplitude-js'
import MainImage from './MainImage.vue'

export default {
	components: {
		MainImage,
	},
	computed: {
		userDevice() {
			return this.$store.getters['userDevice']
		},
		deviceId() {
			return this.$store.getters['deviceId']
		},
	},
	methods: {
		clickTrialBridge() {
			const urlPath = `${window.location.hostname}${this.$route.path}`
			// eslint-disable-next-line no-undef
			gtag('event', 'click_trial_bridge', {
				event_path: urlPath,
				category: '메인 버튼',
			})
		},
		// sendEvent() {
		// 	amplitude.getInstance().init('db978434b67054a87e4a40f950aae62c')
		// 	const event = 'click_goToTrial'
		// 	const eventProperties = {
		// 		domain: 'tella.chat',
		// 		buttonName: this.$t('main.button'),
		// 		objectPlacement: 'Main',
		// 		path: this.$route.path,
		// 	}
		// 	amplitude.getInstance().logEvent(event, eventProperties)
		// 	// amplitude.getInstance().logEvent('EVENT_NAME_HERE')
		// },
	},
}
</script>

<style lang="scss" scoped>
.wrap {
	background-image: linear-gradient(to bottom, #f9f9f9, #f0f0f0);
}
.main-title {
	font-size: 40px;
	font-weight: 900;
	letter-spacing: -0.56px;
	line-height: normal;
	color: #1a1a1a;
	letter-spacing: -2px;

	// line-height: 52px !important;
	// letter-spacing: -0.003em !important;
}
@media screen and (max-width: 600px) {
	.main-title {
		font-size: 28px;
		letter-spacing: -1.4px;
		// line-height: 38px !important;
		// letter-spacing: -0.003em !important;
	}
}

.main-button {
	box-shadow: 0px 16px 32px rgb(0 0 0 / 8%) !important;
}
.main-button:hover {
	box-shadow: unset !important;
}
</style>

<style>
#main .main-button.v-btn:before {
	display: none;
}
</style>
